<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 py-12 font-custom-light min-h-screen">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-black">

      <div class="container mx-auto px-4 max-w-7xl">


        <h3 class="text-3xl text-center font-bold">Confirmación de asistencia</h3>
    

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Nombre" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}"  />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="nombre" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="input-base" placeholder="Apellido" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>          
        </div>
        
      
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 ">
          <div class="w-full px-2 md:w-1/1">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="input-base" placeholder="Mail" :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0}" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
        
        </div>  

        
      </div>

      <BlockUI :blocked="isSubmitting" fullScreen />

    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';
import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import { useRoute } from 'vue-router'


import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';
import HeaderSection from '@/components/HeaderSection.vue'


import suiteService, { Acreditado} from 'qreventos-suite/services';
import {  UPDATE, RECHAZADO } from "qreventos-suite/constantes";
import suiteConfig from '@/services/suite.config';


export default defineComponent({
  components: {
    HeaderSection,
    InputText,
    Field, ErrorMessage, Form, BlockUI
  },
  data() {
    return {
      acreditado: undefined as unknown as Acreditado,
      isSubmitting: false,
      formData: {
        nombre: '',
        apellido: '',
        mail: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        nombre: yup.string().required('Ingresá tu nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingresá tu apellido').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingresá tu correo').email('Correo inválido'),
      });      
    }
  },
  methods: {
    cancelarAcreditacion() {
      this.$router.go(0);
    },
    async onSubmit() {
      this.isSubmitting = true;

    },
  },
  async mounted() {

    const route = useRoute();
    const hash = route.params.hash as string;

    this.acreditado = await suiteService.findAcreditadoByHash(suiteConfig.evento, hash);
    if(!this.acreditado) {
      Swal.fire({ title: "¡Atención!", html: "El acreditado no existe.", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    this.formData.apellido = this.acreditado.apellido;
    this.formData.nombre = this.acreditado.nombre;
    this.formData.mail = this.acreditado.mail;

    if (this.acreditado.tipoAcreditado.id != 2014 && this.acreditado.tipoAcreditado.id != 2017 && this.acreditado.tipoAcreditado.id != 2013) {
      Swal.fire({ title: "¡Atención!", html: "El acreditado no existe.", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    if (this.acreditado.estadoAcreditado.id == 3) {
      Swal.fire({ title: "¡Gracias por responder!", html: "Lamentamos no contar con tu presencia en el evento.", icon: "error" }).then(() => {
        window.location.href = "https://www.nplay.convergencia.com";
        return;
      });
      return;
    }

    try {
        this.acreditado.estadoAcreditado.id = RECHAZADO;
        this.acreditado.notificar = true;
        this.acreditado.modificado = UPDATE;

        await suiteService.saveOrUpdate(suiteConfig.evento, this.acreditado);

        this.isSubmitting = false;
        Swal.fire({
          title: "¡Gracias por responder!",
          html: "Lamentamos no contar con tu presencia en el evento.",
          icon: "success",
        }).then(() => {
          window.location.href = "https://www.nplay.convergencia.com";
        });
        

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
  }
});
</script>